// Mock data for Barham Driver - VTC Chauffeur Privé

export const services = [
  {
    id: 1,
    title: "Transfert simple",
    description: "Profitez d'un trajet fluide et confortable pour vos déplacements quotidiens au Sénégal, avec un chauffeur professionnel à votre disposition dans une voiture électrique climatisée.",
    image: "/images/dakar-driver.png",
    link: "/services/simple-transfer"
  },
  {
    id: 2,
    title: "Transfert aéroport",
    description: "Voyagez sans stress grâce à notre service de transfert aéroport. Arrivée ou départ, nous vous assurons d'être à l'heure avec vos bagages pris en charge.",
    image: "/images/dakar-airport.png",
    link: "/services/airport-transfer"
  },
  {
    id: 3,
    title: "Mise à disposition",
    description: "Bénéficiez d'un véhicule électrique avec chauffeur à votre disposition pour une durée déterminée, idéal pour vos rendez-vous ou événements.",
    image: "/images/dakar-skyline.png",
    link: "/services/hourly-service"
  },
  {
    id: 4,
    title: "Événement soirée",
    description: "Pour vos soirées et événements spéciaux, profitez d'un transport confortable et élégant partout au Sénégal.",
    image: "/images/dakar-event.png",
    link: "/services/event"
  }
];

export const mediaQuotes = [
  {
    id: 1,
    publication: "Client satisfait",
    quote: "Un service impeccable, ponctuel et professionnel. La voiture électrique est un vrai plus !",
    author: "Amadou D.",
    logo: "star"
  },
  {
    id: 2,
    publication: "Client satisfait",
    quote: "Barham Driver m'a accompagné pour mon mariage. Service au top, je recommande vivement.",
    author: "Fatou S.",
    logo: "star"
  },
  {
    id: 3,
    publication: "Client satisfait",
    quote: "Toujours disponible et fiable pour mes transferts aéroport. Merci Barham Driver !",
    author: "Moussa B.",
    logo: "star"
  }
];

export const companySolutions = [
  {
    id: 1,
    name: "Barham Production",
    description: "Transport pour vos équipes et équipements pendant les tournages au Sénégal.",
    icon: "Film",
    link: "/solutions/production"
  },
  {
    id: 2,
    name: "Barham Mariage",
    description: "Transport élégant et serein pour les mariés et leurs invités.",
    icon: "Heart",
    link: "/solutions/wedding"
  },
  {
    id: 3,
    name: "Barham Tourisme",
    description: "Découvrez le Sénégal avec un chauffeur privé expérimenté.",
    icon: "Palmtree",
    link: "/solutions/travel"
  },
  {
    id: 4,
    name: "Barham Business",
    description: "Transport professionnel pour vos séminaires et réunions d'affaires.",
    icon: "Briefcase",
    link: "/solutions/seminar"
  },
  {
    id: 5,
    name: "Barham Événement",
    description: "Service de transport à la hauteur de vos événements spéciaux.",
    icon: "Star",
    link: "/solutions/event"
  }
];

export const commitments = [
  {
    id: 1,
    label: "Fiabilité",
    title: "Arrivez à l'heure, à chaque fois",
    description: "Notre équipe anticipe les conditions de circulation, ajustant les itinéraires en temps réel pour éviter les retards."
  },
  {
    id: 2,
    label: "Confort",
    title: "Vous profitez, nous conduisons",
    description: "Un service conçu pour les personnes qui accordent de l'importance à leur bien-être et à leur temps. Profitez d'un trajet agréable et sûr dans des véhicules confortables."
  },
  {
    id: 3,
    label: "Aller plus loin",
    title: "Vos désirs, notre mission",
    description: "Nous nous engageons à fournir un service exceptionnel en anticipant vos besoins et en personnalisant chaque détail de votre voyage."
  },
  {
    id: 4,
    label: "Service premium",
    title: "Offrez-vous l'excellence",
    description: "Nous offrons une expérience de transport sans compromis, où chaque détail est soigneusement pensé pour dépasser vos attentes."
  }
];

export const vehicleTypes = [
  { value: "nammi-01", label: "Dongfeng Nammi 01 (max. 4 pers.)" }
];

export const occasions = [
  { value: "transfer", label: "Transfert simple" },
  { value: "airport", label: "Transfert aéroport" },
  { value: "event", label: "Événement / Soirée" },
  { value: "wedding", label: "Mariage" },
  { value: "tourism", label: "Visite touristique" },
  { value: "business", label: "Déplacement professionnel" },
  { value: "other", label: "Autre" }
];

export const navLinks = {
  services: [
    { label: "Transfert simple", href: "/services/simple-transfer" },
    { label: "Transfert aéroport", href: "/services/airport-transfer" },
    { label: "Mise à disposition", href: "/services/hourly-service" }
  ],
  companies: [
    { label: "Barham Production", href: "/solutions/production" },
    { label: "Barham Mariage", href: "/solutions/wedding" },
    { label: "Barham Tourisme", href: "/solutions/travel" },
    { label: "Barham Business", href: "/solutions/seminar" },
    { label: "Barham Événement", href: "/solutions/event" }
  ]
};

export const destinations = [
  "Dakar", "Lac Rose", "Saly", "Saint-Louis", "Touba", "Thiès", "Mbour", "AIBD"
];
